import React, { useEffect, useRef } from 'react'
import { RTEModel } from './models/RTE.model'
import '../../styles/@shared/rte.scss'
import LazySection from '../../react-only-components/LazySection'
import { useNavigate, useLocation } from 'react-router-dom'
import { ComponentProps } from '../../types/types'
import withRouter from '../@shared/withRouter'

interface RTEProps extends ComponentProps {}

const getCookieValue = (name) => {
  let result = document && document.cookie.match(
    '(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)'
  )
  return result ? result.pop() : ''
}
const RTE = (props) => {
  const model = new RTEModel(props);
  const navigate = useNavigate();
  const location = useLocation();
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);

  const hydrate = (ref) => {
    if (islangSelector()) {
      setTimeout(() => {
        let el: HTMLCollection = ref?.current?.children[0].children

        var d = new Date()
        d.setTime(d.getTime() + 5 * 24 * 60 * 60 * 1000)
        var expires = 'expires=' + d.toUTCString()

        const hrefun = (currentLang) => {
          const currentPath = location?.pathname
          const prevLang = getCookieValue('cnhicorporate#lang2')
          if (typeof document!== 'undefined') {
            if (currentLang) {
              document.cookie =
                'cnhicorporate#lang2=' + currentLang + ';path=/;' + expires
            } else {
              document.cookie = 'cnhicorporate#lang2=en;path=/;' + expires
            }
          }
         navigate(currentPath);
          //  { forceReload: prevLang != currentLang ? true : false })
        }

        el &&
          Array.from(el).forEach(function (element) {
            const lang = element.getAttribute('datatype')
            element.addEventListener('click', hrefun.bind(element, lang))
          })
      }, 1)
    }
  }

  useEffect(() => {
    hydrate(desktopRef)
  }, [desktopRef.current])

  useEffect(() => {
    hydrate(mobileRef)
  }, [mobileRef.current])

  const isSticky = () => {
    return false //props.params.IsSticky
  }

  const islangSelector = () => {
    return props.params.IslangSelector === 'true'
  }

  return (
    <LazySection id={props?.rendering?.uid}>
      <div
        ref={desktopRef}
        className={`rte__desktop ${isSticky() ? 'sticky' : ''}`}
        dangerouslySetInnerHTML={{ __html: model.html?.value ?? '' }}
      ></div>
      <div
        ref={mobileRef}
        className={`rte__mobile  ${isSticky() ? 'sticky' : ''}`}
        dangerouslySetInnerHTML={{
          __html: (model.mobileHtml?.value || model?.allowFallbackForMobile?.value || model.html?.value || '') as string
            
        }}
      ></div>
    </LazySection>
  )
}
export default withRouter(RTE);
